export const formatNumber = (
  number: number | undefined,
  options?: Intl.NumberFormatOptions,
) => {
  if (number === undefined) {
    return ''
  }

  return new Intl.NumberFormat('cs-CZ', {
    ...options,
  }).format(number)
}
